import { Logger, Source } from '@conteg/logging';

import env from '../env/env';
import { getEnvironmentMode } from '../get-environment-mode/get-environment-mode';

const { isDevelopment } = getEnvironmentMode;

export const logger = new Logger({
  serviceUrl: env?.VITE_LOGGING_URL,
  source: Source.Device,
  token: '1234567890',
  enabled: !isDevelopment,
});
